import { Box, styled, Typography } from "@mui/material";

const ItemLabelBox = styled(Box)(() => ({
    backgroundColor: '#555555',
    width: '100%',
    height: '40px',
}));

const ItemLabelTypography = styled(Typography)(() => ({
    fontSize: '17px',
    color: '#FFFFFF',
    height: '40px',
    lineHeight: '40px',
}));

export { ItemLabelBox, ItemLabelTypography }
